import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import type { Organization } from '../features/jacana/types';
import { normalizeIban } from '../utils/iban';
import { callBackendFunction } from './paymentService';

const ORGANIZATIONS_COLLECTION = 'organizations';
export const DEFAULT_ORGANIZATION_ID = import.meta.env.VITE_ORGANIZATION_ID || 'default';

export const organizationService = {
  async getById(id: string = DEFAULT_ORGANIZATION_ID): Promise<Organization | null> {
    try {
      const ref = doc(db, ORGANIZATIONS_COLLECTION, id);
      const snapshot = await getDoc(ref);
      if (snapshot.exists()) {
        return {
          id: snapshot.id,
          ...(snapshot.data() as Omit<Organization, 'id'>),
        };
      }
    } catch {
      // Fallback via callable when Firestore rules block direct client reads.
    }

    const response = await callBackendFunction<{ orgId: string }, { success: boolean; orgId: string; paymentSettings?: { bankAccount?: string | null } }>(
      'getOrganizationPaymentSettings',
      { orgId: id }
    );

    return {
      id: response.orgId,
      paymentSettings: {
        bankAccount: response.paymentSettings?.bankAccount || undefined,
      },
    };
  },

  async upsertBankAccount(bankAccount: string, id: string = DEFAULT_ORGANIZATION_ID): Promise<void> {
    await callBackendFunction<{ orgId: string; bankAccount: string }, { success: boolean }>(
      'upsertOrganizationBankAccount',
      {
        orgId: id,
        bankAccount: normalizeIban(bankAccount),
      }
    );
  },
};